import {css} from '@sail/engine/deprecated';
import {linkrebrandm1} from './icons/link-rebrand-icon';
import {DefaultTheme, Theme} from './theme';

// from lib/consumer/link_app/frontend/src/theme/tokens/color.ts
// Refer link storybook for more base colors, https://link-ui-storybook.stripe.me/?path=/docs/revamp-system-colors--docs
export const linkColors = {
  neutral: '#FFFFFF',
  neutral100: '#F5F5F5',
  neutral400: '#8D95A1',
  neutral500: '#707070',
  neutral800: '#1d3944',
  neutralBorder: '#0000001F',
  neutral900: '#171717',
  brand: '#00D66F',
  brand50: '#E6FFED',
  brand75: '#B3FECF',
  brand100: '#5EEE97',
  brand200: '#00D66F',
  brand300: '#00C767',
  brand400: '#00A355',
  brand500: '#008545',
  brand600: '#006635',
  brand700: '#034F28',
  brand800: '#023B1E',
  brand900: '#011E0F',
  brand1000: '#5f656eff',
  articleHeading: '#596171',
};

export const LinkTheme: Theme = {
  ...DefaultTheme,
  brandColor: linkColors.brand200,
  onBrandTextColor: linkColors.brand900,
  ctaColor: linkColors.brand200,
  ctaDisabledOpacity: '0.5',
  ctaHoverColor: linkColors.brand100,
  onCtaTextColor: linkColors.brand900,
  onActionPrimaryTextColor: linkColors.neutral,
  textColor: linkColors.neutral800,
  linkColor: linkColors.brand500,
  avatarGradientStart: linkColors.brand200,
  avatarGradientEnd: linkColors.brand200,
  focusVisibleOutline: css.value(`2px solid ${linkColors.brand200}`),
  icon: linkrebrandm1,
  messageKey: 'link',
  surfaceHoverColor: linkColors.neutral100,
  articleHeadingsColor: linkColors.articleHeading,
  articleLinkColor: linkColors.neutral900,
  primaryActionColor: linkColors.neutral900,
  primaryActionActiveColor: linkColors.neutral900,
  primaryActionActiveTextColor: linkColors.neutral100,
  primaryActionColorHoveredKeyline: linkColors.neutral900,
  primaryActionDisabledColor: linkColors.neutral900,
  primaryActionShadow: '0px 1px 2px 0px #0000000A;',
  primaryActionShadowHovered: '0px 1px 2px 0px #0000000A;',
  pressedShadow: '0px 3px 6px 0px #1717171F 0px 7px 14px 0px #17171714',
  hoverBoxShadow: '0px 3px 6px 0px #1717171F 0px 7px 14px 0px #17171714',
  buttonBackgroundImage: `linear-gradient(white, white), linear-gradient(${linkColors.neutralBorder}, ${linkColors.neutralBorder})`,
  buttonBorderWidth: '1px',
  buttonHoverColor: linkColors.brand600,
  messageBubbleBackground: linkColors.brand600,
  messageBubbleText: linkColors.neutral,
  assistantIconColor0: linkColors.brand600,
  assistantIconColor1: linkColors.brand200,
  assistantHeaderTitle: 'Link Support',
  feedbackThumbColor: linkColors.brand600,
  audience: 'link',
  formBorderColor: linkColors.neutralBorder,
  cardBorderRadius: '16px',
  formTitleLabelMarginBottom: 'small',
  formTitleFontSize: '18px',
  formTitleFontWeight: '600',
  formTitleColor: linkColors.neutral900,
  textFieldBackgroundColor: linkColors.neutral100,
  textFieldFocusBackgroundColor: linkColors.neutral,
  textFieldBorder: 'none',
  textFieldBoxShadow: 'none',
  textFieldBorderRadius: 'large',
  textFieldPlaceholderColor: 'text.tertiary',
  textFieldPlaceholderFontSize: '16px',
  textFieldFocusBorder: '1.5px solid',
  textFieldFocusBorderColor: linkColors.neutral900,
  submitButtonPadding: '8px 12px',
  submitButtonBorderRadius: '10px',
  submitButtonDisabledBackground: linkColors.neutral900,
  submitButtonDisabledColor: 'rgba(255,255,255,0.5)',
  focusRing: '0px 0px 0px 0 rgba(0, 0, 0, 0);',
};
